import { defineAsyncComponent } from 'vue';
import { ComponentType } from "../enums";
import AsyncLoaderAnimation from "@/builder/components/shared/AsyncLoaderAnimation.vue";
import ColumnRenderContainer from "@/builder/components/section/ColumnRenderContainer.vue";
import SectionRenderContainer from '@/builder/components/section/SectionRenderContainer.vue';
import FormRenderContainer from '@/builder/components/form/FormRenderContainer.vue';
import FormStepRenderContainer from '@/builder/components/formStep/FormStepRenderContainer.vue';
import TextInputRenderContainer from '@/builder/components/textInput/TextInputRenderContainer.vue';

export const AllComponents = {
    // Static Components that are always needed
    [ComponentType.Column]: ColumnRenderContainer,
    [ComponentType.Form]: FormRenderContainer,
    [ComponentType.FormStep]: FormStepRenderContainer,
    [ComponentType.Section]: SectionRenderContainer,
    [ComponentType.TextInput]: TextInputRenderContainer,

    // Async components that are loaded on demand
    [ComponentType.ButtonGroup]: defineAsyncComponent({
        loader: () => import("@/builder/components/buttonGroup/ButtonGroupRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading ButtonGroup component', error);
        }
    }),
    [ComponentType.Text]: defineAsyncComponent({
        loader: () => import("@/builder/components/text/TextRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Text component', error);
        }
    }),
    [ComponentType.Button]: defineAsyncComponent({
        loader: () => import("@/builder/components/button/ButtonRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Button component', error);
        }
    }),
    [ComponentType.Image]: defineAsyncComponent({
        loader: () => import("@/builder/components/image/ImageRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Image component', error);
        }
    }),
    [ComponentType.Header]: defineAsyncComponent({
        loader: () => import("@/builder/components/header/HeaderRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Header component', error);
        }
    }),
    [ComponentType.DonationBlock]: defineAsyncComponent({
        loader: () => import("@/builder/components/donationBlock/DonationBlockRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading DonationBlock component', error);
        }
    }),
    [ComponentType.Frequency]: defineAsyncComponent({
        loader: () => import("@/builder/components/frequency/FrequencyRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Frequency component', error);
        }
    }),
    [ComponentType.HTML]: defineAsyncComponent({
        loader: () => import("@/builder/components/html/HTMLRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading HTML component', error);
        }
    }),
    [ComponentType.Video]: defineAsyncComponent({
        loader: () => import("@/builder/components/video/VideoRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Video component', error);
        }
    }),
    [ComponentType.Payment]: defineAsyncComponent({
        loader: () => import("@/builder/components/payment/PaymentRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Payment component', error);
        }
    }),
    [ComponentType.Footer]: defineAsyncComponent({
        loader: () => import("@/builder/components/footer/FooterRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Footer component', error);
        }
    }),
    [ComponentType.CoverCost]: defineAsyncComponent({
        loader: () => import("@/builder/components/coverCost/CoverCostRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading CoverCost component', error);
        }
    }),
    [ComponentType.Confirmation]: defineAsyncComponent({
        loader: () => import("@/builder/components/form/ConfirmationRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Confirmation component', error);
        }
    }),
    [ComponentType.Tribute]: defineAsyncComponent({
        loader: () => import("@/builder/components/tribute/TributeRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Tribute component', error);
        }
    }),
    [ComponentType.DoubleTheDonation]: defineAsyncComponent({
        loader: () => import("@/builder/components/doubleTheDonation/DoubleTheDonationContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading DoubleTheDonation component', error);
        }
    }),
    [ComponentType.Premium]: defineAsyncComponent({
        loader: () => import("@/builder/components/premiums/PremiumRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Premium component', error);
        }
    }),
    [ComponentType.Spacer]: defineAsyncComponent({
        loader: () => import("@/builder/components/spacer/SpacerRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Spacer component', error);
        }
    }),
    [ComponentType.Divider]: defineAsyncComponent({
        loader: () => import("@/builder/components/divider/DividerRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Divider component', error);
        }
    }),
    [ComponentType.Icon]: defineAsyncComponent({
        loader: () => import("@/builder/components/icon/IconRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading Icon component', error);
        }
    }),
    [ComponentType.ProgressBar]: defineAsyncComponent({
        loader: () => import("@/builder/components/progressBar/ProgressBarRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading ProgressBar component', error);
        }
    }),
    [ComponentType.AnonymousGiving]: defineAsyncComponent({
        loader: () => import("../components/anonymousGiving/AnonymousGivingRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading AnonymousGiving component', error);
        }
    }),
    [ComponentType.CustomField]: defineAsyncComponent({
        loader: () => import("../components/customField/CustomFieldRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading CustomField component', error);
        }
    }),
    [ComponentType.CustomCollection]: defineAsyncComponent({
        loader: () => import("../components/customCollection/CustomCollectionRenderContainer.vue"),
        loadingComponent: AsyncLoaderAnimation,
        delay: 200,
        onError: (error) => {
            console.log('Error loading CustomCollection component', error);
        }
    }),
};
